import { Navigate, useRoutes } from 'react-router-dom';
import MainLayout from 'layout/MainLayout';
import MinimalLayout from 'layout/MinimalLayout';
import { publicRoutes } from './PublicRoutes';
import { useSelector } from 'react-redux';
import DashboardRouters from './DashboardRouters';
import AdminRouters from './Admin';
import ManagmentProjectsRouters from './ManagmentProjects';
import MyProjectsRouters from './MyProjects';
import UploadFormRoute from './UploadFormRoute';
import ProvidersRouters from './ProvidersRouters';

export default function ThemeRoutes() {
  const { user } = useSelector((state) => state.user);

  const isUserLoggedIn = Boolean(user);

  const adminRole = user && JSON.parse(user?.reloadUserInfo?.customAttributes).role === 'ADMIN_ROLE';
  const pmRole = user && JSON.parse(user?.reloadUserInfo?.customAttributes).role === 'PM_ROLE';

  const defaultRouterLogged = adminRole || pmRole ? '/projectsManagement' : '/projects';
  const isFormatOK = user ? JSON.parse(user?.reloadUserInfo?.customAttributes).isFormatOK : false;

  const routes = [
    {
      element: isUserLoggedIn ? <MainLayout /> : <Navigate to="/home" />,
      children: DashboardRouters
    },
    {
      element: isUserLoggedIn ? <MainLayout /> : <Navigate to="/home" />,
      children: MyProjectsRouters
    },
    {
      element: isUserLoggedIn ? <MainLayout /> : <Navigate to="/home" />,
      children: ProvidersRouters
    },
    {
      element: isUserLoggedIn && (adminRole || pmRole) ? <MainLayout /> : <Navigate to="/home" />,
      children: ManagmentProjectsRouters
    },
    {
      element: isUserLoggedIn && adminRole ? <MainLayout /> : <Navigate to="/home" />,
      children: AdminRouters
    },
    {
      element: isUserLoggedIn && !isFormatOK && !(adminRole || pmRole) ? <MainLayout /> : <Navigate to="/home" />,
      children: UploadFormRoute
    },
    {
      element: !isUserLoggedIn ? <MinimalLayout /> : <Navigate to={isFormatOK ? defaultRouterLogged : '/upload-format-file-validating'} />,
      children: publicRoutes
    },
    {
      path: '*',
      element: <Navigate to={isUserLoggedIn ? defaultRouterLogged : '/home'} />
    }
  ];

  return useRoutes(user !== undefined ? routes : []);
}
